export class BudgetItem {
    // description: string;
    // amount: number;


    constructor( public description: string,  public amount: number){}
}